<template>
  <div>
    <div class="page-section">
      <div class="title-page">Dados da solicitação</div>
      <section class="section-service col-12">
        <q-form ref="formtab1">
          <div class="group-input col-12 row q-mt-sm">
            <label for="type-os">Tipo de OS</label>
            <q-select id="type-os" class="col-12 q-mt-sm form-tabulacao" outlined dense ref="typeOSRef"
              v-model="requestData.typeOS" color="red-9"  use-input hide-selected
              fill-input input-debounce="0" :options="listTypeOS" option-value="value"
              @update:model-value="isEnablePaymentByTypeOs(requestData.typeOS)"
              option-label="text" bg-color="white" :rules="[(val) => !!val || 'Campo Obrigatório']" lazy-rules />
          </div>

          <div class="group-input col-12 column q-mt-lg">
            <label for="write-off-code">Tipo de agendamento</label>
            <div class="radio-options">
              <q-radio v-model="requestData.movimentscheduling" keep-color size="lg" :val="1"
                label="Realizar agendamento" color="red-6"
                @update:model-value="isEnableByMovimentTerminal(false)"  disable/>
              <q-radio v-model="requestData.movimentscheduling" keep-color size="lg" :val="0" label="Abertura imediata"
                color="red-6" :disable="inputsDisabledMenagement.movimentTerminal"
                @update:model-value="isEnableByMovimentTerminal(true)" disable/>
            </div>
          </div>

          <div class="group-input col-12 column q-mt-lg" v-if="isEnablePayment">
            <label for="write-off-code">Plano de pagamento</label>
            <div class="radio-options">
              <q-radio v-model="requestData.payment" keep-color size="lg" val="À vista" label="À vista" color="red-6"
                @update:model-value="isEnableByMovimentTerminal(false)" />
              <q-radio v-model="requestData.payment" keep-color size="lg" val="2 vezes" label="2 vezes" color="red-6"
                @update:model-value="isEnableByMovimentTerminal(true)" />
            </div>
          </div>

          <div class="column">
            <div class="group-input col-12 row q-mt-lg">
              <label for="write-off-code">Código de Baixa</label>
              <q-select id="write-off-code" class="col-12 q-mt-sm" outlined dense ref="writeOffCodeRef"
                v-model="requestData.writeOffCode" color="red-9" use-input hide-selected
                fill-input input-debounce="0" :options="optionsItens.optionsWriteOffCode"
                :disable="inputsDisabledMenagement.waterMark" option-value="value" option-label="text" bg-color="white"
                :rules="[(val) => !!val || 'Campo Obrigatório']" lazy-rules />
            </div>
          </div>

          <div class="group-input col-12 row q-mt-md">
            <label for="observation">Observação</label>
            <div class="col-12 row flex justify-around">
              <q-input v-model="requestData.observation" class="col-12 q-mt-sm" bg-color="white" color="red-9"
                maxlength="120" outlined autogrow :rules="[(val) => !!val || 'Campo Obrigatório']" lazy-rules />
            </div>
          </div>
        </q-form>
        <section>
          <div>
            <q-footer>
              <q-toolbar elevated>
                <div class="flex col-12 row items-center justify-between">
                  <div class="col-4 justify-center flex items-center">
                    <q-btn unelevated outline rounded color="red-9" @click="$emit('removeEdit')" label="Cancelar" />
                  </div>
                  <div class="col-4 justify-center flex items-center">
                    <q-btn unelevated rounded color="red-9" @click="validateForm()" label="Concluir" />
                  </div>
                </div>
              </q-toolbar>
            </q-footer>
          </div>
        </section>
      </section>
    </div>
  </div>
</template>

<script>
import DateTimePicker from "@/components/DateTimePicker";
import SelectCheckbox from "@/components/SelectCheckbox";
import moment from "moment";
import { useQuasar } from "quasar";
import { onMounted, reactive, ref } from "vue";
//----QUASAR

export default {
  name: "FormSolicitation",
  components: {
    SelectCheckbox,
    DateTimePicker,
  },
  props: {
    listWriteOffCode: Array,
    listTypeOS: Array,
    optionsWriteOffCode: Array,
    optionsTypeOS: Array,
    itemOsContract: Object,
    typeAttendance: Number,
  },
  emits: [
    "saveSchemaRequest",
    "clearSchemaRequest",
    "removeEdit",
    "getTypeOsClassification",
  ],

  setup(props, { emit }) {
    moment.locale("pt-br");
    const $q = useQuasar()
    const ACTION_INSTALLED_ID = ref(2);
    const ACTION_DEVOLUTION_ID = ref(3);

    let panel = ref("tab-1");
    let tabindex = ref(1);
    let progressBar = ref(0.5);

    let requestData = reactive(props.itemOsContract);

    let contract = reactive({
      osRequests: [],
    });
    let confirmationReplicateWriteOffCode = ref(false);
    let modalReplicateWriteOffCode = ref(false);
    let inputsDisabledMenagement = ref({
      movimentTerminal: false,
      action: false,
      state: false,
      waterMark: false,
      osInfoNumber: false,
      canEditEquipment: false,
      isShowUninstallEquipment: true,
      isShowUninstallSmartCard: true,
      osInfoNumber: false,
      isDisabledSmartCard: false,
    });

    let schemaRequest = reactive({
      object_id: "",
      osNumber: "",
      typeOS: "",
      statusOS: 1,
      writeOffCode: "",
      observation: "",
      check: false,
      replicate: false,
      source: "",
      action: 1,
      state: 1,
      equipamentNumberInstall: "",
      equipamentNumberDesinstall: "",
      cardNumberInstaled: "",
      cardNumberUninstalled: "",
    });
    let isEnablePayment = ref(false);
    const formtab1 = ref(null);

    const listTypeOS = ref([]);
    const acceptWriteOffCode = ref([409,511,512]);

    const optionsItens = ref({
      optionsTypeOS: props.listTypeOS,
      optionsWriteOffCode: props.listWriteOffCode,
    });


    const listOfWriteOffCodeAttendanceTrocaTecnica = [530];
    const datesHoursAvailableForSelection = reactive({
      date: [],
      hour: [
        {
          id: 1,
          text: "08h - 12h",
          value: "08 - 12",
        },
        {
          id: 2,
          text: "12h - 15h",
          value: "12 - 15",
        },
        {
          id: 3,
          text: "15h - 18h",
          value: "15 - 18",
        },
      ],
    });


    function filterWriteOffCode() {
      optionsItens.value.optionsWriteOffCode = props.optionsWriteOffCode.filter((writeOffCode) => {
        return acceptWriteOffCode.value.includes(writeOffCode.value)
      });
    }

    async function validateForm() {
      let validation = false;
      if (requestData.payment == null && isEnablePayment.value) {
        $q.notify({
          message: 'Você precisa selecionar o metodo de pagamento',
          color: "red-9",
          position: "top",
          timeout: 3000,
        });
        return;
      }

      validation = await formtab1.value.validate();

      if (validation) {
        emitData()
      }
      
      return validation;
    }

    function emitData() {
      emit("saveSchemaRequest", requestData);
    }

    function isEnableByMovimentTerminal(state) {
      if (props.typeAttendance == "6" || props.typeAttendance == "7") {
        inputsDisabledMenagement.value.action = state;
        return;
      }
      inputsDisabledMenagement.value.action = state;
      inputsDisabledMenagement.value.state = state;
    }

    function isEnablePaymentByTypeOs(typeOs) {
      if (typeOs.value == 142) {
        isEnablePayment.value = true;
      } else {
        isEnablePayment.value = false;
        requestData.payment = null;
      }
    }

    onMounted(() => {
      filterWriteOffCode() 
    });

    return {
      ACTION_INSTALLED_ID,
      ACTION_DEVOLUTION_ID,
      inputsDisabledMenagement,
      datesHoursAvailableForSelection,
      panel,
      tabindex,
      progressBar,
      schemaRequest,
      requestData,
      optionsItens,
      isEnablePayment,
      formtab1,
      confirmationReplicateWriteOffCode,
      modalReplicateWriteOffCode,
      filterWriteOffCode,
      validateForm,
      isEnableByMovimentTerminal,
      isEnablePaymentByTypeOs
    };
  },
};
</script>

<style scoped lang="scss">

.page-section{
  display: flex;
  min-height: 583px;
  padding: 0 21px;
  flex-direction: column;
  // height: 100%;
}

label {
  font-family: Roboto;
  font-style: normal;
}

.q-page-container {
  padding-bottom: 0px !important;
}

.label-checkbox-confirm {
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 14px !important;
  letter-spacing: 0.01em !important;
  color: #999999 !important;
}

.radio-options{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

footer {
  background: #e5e5e5 !important;
  height: 12vh;

  .q-toolbar {
    height: 12vh;
  }

  .div-progress {
    height: 8vh;
  }

  .div-btn-next {
    height: 8vh;
  }
}

.section-service {
  width: 100%;

  .panel-services {
    background: transparent !important;
    overflow: hidden !important;

    .title-page {
      font-weight: bold;
      font-size: 18px;
      line-height: 19px;
      text-transform: uppercase;
      color: #e2262d;
    }

    .group-input {
      label {
        font-weight: bold;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.4);
      }
    }

    .label-requests-number {
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.5);
    }

    .label-requests-description {
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.8);
    }
  }
}
</style>
